import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import TermsOfService from "../pages/legal/TermsOfService";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import CookiePolicy from "../pages/legal/CookiePolicy";
import AMLPolicy from "../pages/legal/AMLPolicy";
import RiskDisclosure from "../pages/legal/RiskDisclosure";
import UserAgreement from "../pages/legal/UserAgreement";
import AboutPage from "../pages/company/AboutPage";
import CareersPage from "../pages/company/CareersPage";
import ContactPage from "../pages/company/ContactPage";
import PressPage from "../pages/company/PressPage";
import BrandPage from "../pages/company/BrandPage";
import MarketsPage from "../pages/product/MarketsPage";
import AIAgentsPage from "../pages/product/AIAgentsPage";
import VaultsPage from "../pages/product/VaultsPage";
import LeaderboardPage from "../pages/product/LeaderboardPage";
import FeesPage from "../pages/product/FeesPage";
import ApiReferencePage from "../pages/developers/ApiReferencePage";
import SDKsPage from "../pages/developers/SDKsPage";
import SkillsListPage from "../pages/skills/SkillsListPage";
import SkillDetailPage from "../pages/skills/SkillDetailPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/skills",
    element: <SkillsListPage />,
  },
  {
    path: "/skills/:skillId",
    element: <SkillDetailPage />,
  },
  {
    path: "/terms",
    element: <TermsOfService />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/cookies",
    element: <CookiePolicy />,
  },
  {
    path: "/aml",
    element: <AMLPolicy />,
  },
  {
    path: "/risk",
    element: <RiskDisclosure />,
  },
  {
    path: "/agreement",
    element: <UserAgreement />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/careers",
    element: <CareersPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/press",
    element: <PressPage />,
  },
  {
    path: "/brand",
    element: <BrandPage />,
  },
  {
    path: "/markets",
    element: <MarketsPage />,
  },
  {
    path: "/ai-agents",
    element: <AIAgentsPage />,
  },
  {
    path: "/vaults",
    element: <VaultsPage />,
  },
  {
    path: "/leaderboard",
    element: <LeaderboardPage />,
  },
  {
    path: "/fees",
    element: <FeesPage />,
  },
  {
    path: "/api-reference",
    element: <ApiReferencePage />,
  },
  {
    path: "/sdks",
    element: <SDKsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
